import { BASE } from "./index";
import axios from "./http";

const fz = {

  //装卸账户动帐列表
  balancelist: (params) =>
    axios.post(`${BASE.PRO1}/fleet/wallet/balance/list`, params),
  //筛选条件
  flowtype: (params) =>
    axios.post(`${BASE.PRO1}/fleet/flow/type`, params),
  //装卸队列表（筛选用）
  fleetlist: (params) =>
    axios.post(`${BASE.PRO1}/fleet/list`, params),
  //新增装卸队动帐申请
    balanceadd: (params) =>
        axios.post(`${BASE.PRO1}/fleet/wallet/balance/add`, params),
  //装卸队动帐申请审批
    balanceaudit: (params) =>
        axios.post(`${BASE.PRO1}/fleet/wallet/balance/audit`, params),
  //装卸队动帐申请确认信息
    balancepre: (params) =>
        axios.post(`${BASE.PRO1}/fleet/wallet/balance/pre`, params),
  //装卸队动帐审批作废
    balancecancel: (params) =>
        axios.post(`${BASE.PRO1}/fleet/wallet/balance/cancel`, params),
  //装卸账户明细
    flowlist: (params) =>
        axios.post(`${BASE.PRO1}/fleet/wallet/flow/list`, params),
  //装卸账户列表
    walletlist: (params) =>
        axios.post(`${BASE.PRO1}/fleet/wallet/list`, params),
  //装卸收入
    walletstatement: (params) =>
        axios.post(`${BASE.PRO1}/fleet/wallet/statement`, params),

  //装卸收入详情导出
    detailexport: (params) =>
        axios.post(`${BASE.EXPORT_CENTER}/bi/fleet/wallet/statement/detail/export`, params),

  //装卸收入导出
    statementexport: (params) =>
        axios.post(`${BASE.EXPORT_CENTER}/bi/fleet/wallet/statement/export`, params),
  //装卸账户列表导出
    walletexport: (params) =>
        axios.post(`${BASE.EXPORT_CENTER}/bi/fleet/wallet/export`, params),
  //装卸账户动帐列表导出
    balanceexport: (params) =>
        axios.post(`${BASE.EXPORT_CENTER}/bi/fleet/wallet/balance/export`, params),
  //装卸账户明细导出
    flowexport: (params) =>
        axios.post(`${BASE.EXPORT_CENTER}/bi/fleet/wallet/flow/export`, params),

};

export default fz;
